import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(() => ({
	pageContainer: {
		position: "fixed",
		top: 0,
		left: 0,
		height: "100%",
		width: "100%",
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		zIndex: 1203
	},
	widgetEditorIframe: {
		width: "100%",
		height: "100%",
		border: "none"
	}
}))

export default useStyles
